/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-sql-cross-join-visualizer block)");
/* eslint-enable no-console */

(function () {
    const datasets = {
        customersOrders: {
            leftName: "clients", rightName: "commandes",
            leftRows: [
                { id: 1, nom: "Alice" },
                { id: 2, nom: "Bob" },
                { id: 3, nom: "Charlie" }
            ],
            rightRows: [
                { produit: "Stylo", prix: 2 },
                { produit: "Cahier", prix: 5 },
                { produit: "Règle", prix: 3 }
            ]
        },
        employeesDepartments: {
            leftName: "employes", rightName: "departements",
            leftRows: [
                { employee_id: 1, nom: "Emma" },
                { employee_id: 2, nom: "Liam" },
                { employee_id: 3, nom: "Noah" }
            ],
            rightRows: [
                { id: 10, departement: "Ventes" },
                { id: 20, departement: "Marketing" },
                { id: 30, departement: "Finance" }
            ]
        },
        colorsSize: {
            leftName: "couleurs", rightName: "tailles",
            leftRows: [
                { couleur: "Rouge" },
                { couleur: "Bleu" },
                { couleur: "Vert" }
            ],
            rightRows: [
                { taille: "S" },
                { taille: "M" },
                { taille: "L" },
                { taille: "XL" }
            ]
        }
    };

    // — DOM —
    const datasetEl = document.getElementById("cjDataset");
    const tableAWrap = document.getElementById("cjTableAWrap");
    const tableBWrap = document.getElementById("cjTableBWrap");
    const resultWrap = document.getElementById("cjResultWrap");
    const resultMeta = document.getElementById("cjResultMeta");
    const sqlCode = document.getElementById("cjSqlCode");
    const tableATitle = document.getElementById("cjTableATitle");
    const tableBTitle = document.getElementById("cjTableBTitle");
    const cartTable = document.getElementById("cjCartTable");
    const toggleTableA = document.getElementById("toggleCjTableA");
    const toggleTableB = document.getElementById("toggleCjTableB");
    const toggleDiagram = document.getElementById("toggleCjDiagram");
    const toggleResult = document.getElementById("toggleCjResult");
    const toggleSql = document.getElementById("toggleCjSql");
    const panelTableA = document.getElementById("cjPanelTableA");
    const panelTableB = document.getElementById("cjPanelTableB");
    const sectionTables = document.getElementById("cjSectionTables");
    const diagramWrap = document.getElementById("cjDiagramWrap");
    const blockSql = document.getElementById("cjBlockSql");
    const blockResult = document.getElementById("cjBlockResult");
    const divider = document.getElementById("cjDivider");

    // — Utilitaires —
    function getColumns(rows) {
        const cols = new Set();
        rows.forEach(r => Object.keys(r).forEach(k => cols.add(k)));
        return [...cols];
    }

    function escapeHtml(v) {
        return String(v ?? "")
            .replace(/&/g, "&amp;").replace(/</g, "&lt;")
            .replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }

    // Résumé court d'une ligne : "val1, val2"
    function rowLabel(row) {
        return Object.values(row).map(v => String(v ?? "")).join(", ");
    }

    // — Tables sources —
    function renderTable(container, rows) {
        if (!rows.length) { container.innerHTML = '<div class="cj-empty">Aucune ligne.</div>'; return; }
        const cols = getColumns(rows);
        let html = "<table><thead><tr>" + cols.map(c => `<th>${escapeHtml(c)}</th>`).join("") + "</tr></thead><tbody>";
        rows.forEach((row, i) => {
            html += `<tr data-idx="${i}">` + cols.map(c => `<td>${escapeHtml(row[c] ?? "NULL")}</td>`).join("") + "</tr>";
        });
        html += "</tbody></table>";
        container.innerHTML = html;
    }

    // — Calcul CROSS JOIN —
    function computeCrossJoin(leftRows, rightRows) {
        const lCols = getColumns(leftRows);
        const rCols = getColumns(rightRows);
        const result = [];
        leftRows.forEach(lr => {
            rightRows.forEach(rr => {
                const row = {};
                lCols.forEach(c => row["A." + c] = lr[c] ?? null);
                rCols.forEach(c => row["B." + c] = rr[c] ?? null);
                result.push(row);
            });
        });
        return result;
    }

    // — Tableau résultat —
    function renderResult(rows) {
        if (!rows.length) { resultWrap.innerHTML = '<div class="cj-empty">Aucune ligne.</div>'; return; }
        const cols = getColumns(rows);
        const lCols = cols.filter(c => c.startsWith("A."));
        const rCols = cols.filter(c => c.startsWith("B."));

        let html = "<table><thead><tr>"
            + lCols.map(c => `<th class="cj-th-a">${escapeHtml(c)}</th>`).join("")
            + rCols.map(c => `<th class="cj-th-b">${escapeHtml(c)}</th>`).join("")
            + "</tr></thead><tbody>";

        rows.forEach((row, i) => {
            html += `<tr data-result-idx="${i}">`
                + lCols.map(c => `<td class="cj-td-a">${escapeHtml(row[c] ?? "NULL")}</td>`).join("")
                + rCols.map(c => `<td class="cj-td-b">${escapeHtml(row[c] ?? "NULL")}</td>`).join("")
                + "</tr>";
        });
        html += "</tbody></table>";
        resultWrap.innerHTML = html;

        // Hover sur résultat → highlight tableau cartésien
        resultWrap.querySelectorAll("tr[data-result-idx]").forEach(tr => {
            const idx = parseInt(tr.dataset.resultIdx);
            tr.addEventListener("mouseenter", () => highlightRow(idx));
            tr.addEventListener("mouseleave", () => highlightRow(-1));
        });
    }

    // — Tableau cartésien (remplace la matrice CSS) —
    function renderCartTable(leftRows, rightRows) {
        const rLabels = rightRows.map(r => rowLabel(r));
        const lLabels = leftRows.map(r => rowLabel(r));

        // En-tête : coin vide + labels table B
        let html = "<thead><tr><th class='cj-cart-corner'>A \\ B</th>"
            + rLabels.map(rl => `<th class="cj-cart-col-header">${escapeHtml(rl)}</th>`).join("")
            + "</tr></thead><tbody>";

        // Lignes : label table A + cellules combinaisons
        leftRows.forEach((lr, li) => {
            html += `<tr><th class="cj-cart-row-header">${escapeHtml(lLabels[li])}</th>`;
            rightRows.forEach((rr, ri) => {
                const resultIdx = li * rightRows.length + ri;
                html += `<td class="cj-cart-cell" data-result-idx="${resultIdx}" title="Ligne ${resultIdx + 1} du résultat">
                    ${escapeHtml(lLabels[li])} × ${escapeHtml(rLabels[ri])}
                </td>`;
            });
            html += "</tr>";
        });

        html += "</tbody>";
        cartTable.innerHTML = html;

        // Événements sur les cellules
        cartTable.querySelectorAll(".cj-cart-cell").forEach(cell => {
            const idx = parseInt(cell.dataset.resultIdx);
            cell.addEventListener("mouseenter", () => highlightRow(idx));
            cell.addEventListener("mouseleave", () => highlightRow(-1));
            cell.addEventListener("click", () => scrollToResultRow(idx));
        });
    }

    // — Highlight bidirectionnel —
    function highlightRow(idx) {
        cartTable.querySelectorAll(".cj-cart-cell").forEach(c => {
            c.classList.toggle("cj-cell-active", parseInt(c.dataset.resultIdx) === idx);
        });
        resultWrap.querySelectorAll("tr[data-result-idx]").forEach(tr => {
            tr.classList.toggle("cj-highlight", parseInt(tr.dataset.resultIdx) === idx);
        });
    }

    function scrollToResultRow(idx) {
        const tr = resultWrap.querySelector(`tr[data-result-idx="${idx}"]`);
        if (tr) tr.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    // — Visibilité —
    function updateVisibility() {
        const showA = toggleTableA.checked;
        const showB = toggleTableB.checked;
        panelTableA.classList.toggle("cj-hidden", !showA);
        panelTableB.classList.toggle("cj-hidden", !showB);
        sectionTables.classList.toggle("cj-hidden", !showA && !showB);
        diagramWrap.classList.toggle("cj-hidden", !toggleDiagram.checked);
        blockSql.classList.toggle("cj-hidden", !toggleSql.checked);
        blockResult.classList.toggle("cj-hidden", !toggleResult.checked);
        divider.classList.toggle("cj-hidden", !toggleSql.checked && !showA && !showB);
    }

    // — Rendu principal —
    function renderAll() {
        const data = datasets[datasetEl.value];
        const { leftName, rightName, leftRows, rightRows } = data;

        tableATitle.textContent = "Table A — " + leftName;
        tableBTitle.textContent = "Table B — " + rightName;

        renderTable(tableAWrap, leftRows);
        renderTable(tableBWrap, rightRows);

        const result = computeCrossJoin(leftRows, rightRows);
        renderResult(result);
        renderCartTable(leftRows, rightRows);

        sqlCode.textContent = `SELECT *\nFROM ${leftName}\nCROSS JOIN ${rightName};`;
        resultMeta.textContent = `CROSS JOIN entre ${leftName} (${leftRows.length} lignes) × ${rightName} (${rightRows.length} lignes) = ${result.length} ligne(s) résultante(s).`;

        updateVisibility();
    }

    // — Événements —
    [toggleTableA, toggleTableB, toggleDiagram, toggleResult, toggleSql]
        .forEach(el => el.addEventListener("change", updateVisibility));
    datasetEl.addEventListener("change", renderAll);
    document.getElementById("cjReloadBtn").addEventListener("click", renderAll);

    document.getElementById("cjShareBtn").addEventListener("click", () => {
        const url = window.location.href;
        if (navigator.share) {
            navigator.share({ title: "Visualiseur CROSS JOIN SQL", url }).catch(() => { });
        } else {
            navigator.clipboard.writeText(url).then(() => {
                const toast = document.getElementById("cjShareToast");
                toast.style.display = "block";
                setTimeout(() => { toast.style.display = "none"; }, 2500);
            }).catch(() => { prompt("Copiez ce lien :", url); });
        }
    });

    renderAll();
})()
